import React, { useEffect } from 'react';
import styled from '@xstyled/styled-components';
import { isDesktop } from 'react-device-detect';
import { css } from 'styled-components';
import { FC } from 'react';
import { x } from '@xstyled/styled-components';
import { useDoorsStore } from '../DoorsStore';
import { getIcon } from '../../text/Icons';

const StyledWrapper = styled.divBox<{
  header: boolean;
  bottomAligned?: boolean;
}>`
  /* When instructional content is rendered above the doors, lay the slide out as
     a column and push everything to the bottom so the empty vertical space sits
     above the text (which then ends up just above the doors). */
  ${p =>
    p.bottomAligned &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 100%;
    `}

  ul {
    margin: 0 auto;
    display: grid;
    width: 80%;
    max-width: 950px;
    height: ${p => (p.header ? '65%' : '75%')};
    min-height: ${p => (p.header ? '400px' : '490px')};

    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 64px;

    li {
      display: flex;
      width: 26%;
      height: auto;
      button {
        width: unset;
      }
    }

    @media (max-width: lg) {
      min-height: 490px;
      max-width: 95%;
    }

    @media (max-width: md) {
      min-height: 380px;
      height: 65%;
      gap: 32px;
    }

    @media (max-width: sm) {
      min-height: 270px;
      height: 50%;
      gap: 16px;
    }

    @media (max-height: 500px) {
      height: 80%;
    }
  }

  /* In the bottom-aligned layout the doors list hugs its content so the
     instructional text sits directly on top of the doors. */
  ${p =>
    p.bottomAligned &&
    css`
      ul {
        height: auto;
        min-height: 0;
        @media (max-width: lg),
          (max-width: md),
          (max-width: sm),
          (max-height: 500px) {
          height: auto;
          min-height: 0;
        }
      }
    `}// https://linear.app/easyllama/issue/CAT-6/door-slides-content-is-confusing-in-small-iframe

  /* ${
    isDesktop &&
    css`
      min-height: 750px !important;
    `
  } */
`;

const HeaderContent = styled.h2`
  font-size: 24px;
  line-height: 50px;
  text-align: center;
  width: fit-content;

  @media (max-width: sm) {
    font-size: 16px;
    line-height: 30px;
  }
`;

export const Wrapper: FC<{
  header?: { title: string[]; subtitle: string; icon: string };
  bottomAligned?: boolean;
}> = ({ header, bottomAligned, children }) => {
  const { items, setItems, setQuizAnswer } = useDoorsStore();
  const Icon = getIcon(header?.icon);

  useEffect(() => {
    if (header && header.title) {
      setItems(header.title);
      setQuizAnswer('_________');
    }
  }, []);

  return (
    <StyledWrapper header={Boolean(header)} bottomAligned={bottomAligned}>
      {header && header.title && header.subtitle && (
        <x.div
          pt={50}
          zIndex={100}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          gap={10}
        >
          <x.div
            color="accentDark"
            w="100%"
            maxW="100%"
            overflow="visible"
            className="subtitleStyleForDarkTheme"
          >
            <x.span
              display="block"
              fontFamily="'Plus Jakarta Sans', sans-serif"
              fontWeight={600}
              fontSize="14px"
              lineHeight={1.5}
              letterSpacing="0.05em"
              textTransform="uppercase"
              whiteSpace="normal"
              style={{ wordBreak: 'break-word' }}
            >
              {header.subtitle}
            </x.span>
          </x.div>
          <HeaderContent>
            {items
              .map(item =>
                typeof item === 'string'
                  ? item + ' '
                  : typeof (item as React.ReactElement<{ children?: unknown }>)
                        ?.props?.children === 'string'
                    ? (item as React.ReactElement<{ children?: unknown }>)
                        ?.props?.children
                    : ''
              )
              .join(' ')}
          </HeaderContent>
        </x.div>
      )}
      {children}
    </StyledWrapper>
  );
};
